export default "__VITE_ASSET__Br8IWeOR__"